import { createRouter, createWebHistory } from "vue-router";
import MainLayout from '../layout/MainLayout.vue'
import Home from '../views/home/index.vue'
import Mine from '../views/mine/index.vue'
import Order from '../views/order'
import OrderDetail from '../views/order/orderDetail.vue'
import OrderList from '../views/order/orderList.vue'
import OrderView from '../views/order/orderView.vue'
import OrderForm from '../views/order/orderForm.vue'
import PaySuccess from '../views/order/paySuccess.vue'
import ConsultationBook from '../views/consultationBook/index.vue'
import ConsultationBookDetail from '../views/consultationBook/detail.vue'
import AddClue from '../views/consultationBook/add.vue'
import AddFollowRecord from '../views/consultationBook/addFollowRecord.vue'
import AddAttendance from '../views/schedule/addAttendance.vue'
import EditSchedulePlan from '../views/schedule/editSchedulePlan.vue'
import EditAttendance from '../views/schedule/editAttendance.vue'
import EditAttendanceSchedulePlan from '../views/schedule/editAttendanceSchedulePlan.vue'
import TeachingLog from '../views/schedule/teachingLog.vue'
import MyTeachingLog from '../views/schedule/myTeachingLog.vue'
import TeachingLogDetail from '../views/schedule/teachingLogDetail.vue'
import TimeTable from '../views/schedule/timeTable.vue'
import AddSchedule from '../views/schedule/addSchedule.vue'
import AddStudentSchedule from '../views/schedule/addStudentSchedule.vue'
import PhoneBank from '../views/phoneBank/index.vue'
import PhoneBankRecord from '../views/phoneBank/record.vue'
import PhoneBankAddRecord from '../views/phoneBank/addRecord.vue'
import Login from '../views/sideline/login.vue'
import CustomerDetail from '../views/crm/CustomerDetail.vue'
import SchoolDetail from '../views/schoolCompleteInfo/schoolDetail.vue'

const routes = [
  {
    path: '/',
    component: MainLayout,
    children: [
      {
        path: '',
        name: 'Home',
        component: Home,
        meta: { title: '教务工作台', hideFAB: true, keepAlive: true }
      },
      {
        path: 'mine',
        name: 'Mine',
        component: Mine,
        meta: { title: '我的', hideFAB: true, keepAlive: true }
      },
      {
        path: 'timeTable',
        name: 'TimeTable',
        component: TimeTable,
        meta: { title: '课表', hideFAB: true }
      },
      {
        path: 'consultationBook',
        name: 'ConsultationBook',
        component: ConsultationBook,
        meta: { title: '线索管理', hideFAB: true, keepAlive: true }
      },
      {
        path: 'phoneBank',
        name: 'PhoneBank',
        component: PhoneBank,
        meta: { title: '号码库', hideFAB: true }
      },
      {
        path: 'checkin',
        name: 'Checkin',
        component: () => import('../views/checkin/index.vue'),
        meta: { title: '地推打卡', hideFAB: true }
      },
      {
        path: 'referral/ranking',
        name: 'ReferralRanking',
        component: () => import('../views/referral/ranking.vue'),
        meta: { title: '转介绍榜单', hideFAB: true, keepAlive: true }
      }
    ]
  },
  {
    path: '/teachingLog',
    name: 'TeachingLog',
    component: TeachingLog,
    meta: { title: '考勤记录', hideFAB: true }
  },
  {
    path: '/myTeachingLog',
    name: 'MyTeachingLog',
    component: MyTeachingLog,
    meta: { title: '上课记录', hideFAB: true, keepAlive: true }
  },
  {
    path: '/order',
    name: Order,
    component: Order,
    meta: { title: '订单审核' }
  },
  {
    path: '/orderList',
    name: 'OrderList',
    component: OrderList,
    meta: { title: '订单管理', hideFAB: true, keepAlive: true }
  },
  {
    path: '/orderView',
    name: 'OrderView',
    component: OrderView,
    meta: { title: '订单详情', hideFAB: true }
  },
  {
    path: '/orderForm',
    name: 'OrderForm',
    component: OrderForm,
    meta: { title: '订单录入', hideFAB: true }
  },
  {
    path: '/orderDetail/:paymentOrderId',
    name: OrderDetail,
    component: OrderDetail,
    meta: { title: '订单详情', hideFAB: true }
  },

  {
    path: '/consultationBook/add',
    name: AddClue,
    component: AddClue,
    meta: { title: '新增咨询线索', hideFAB: true }
  },
  {
    path: '/consultationBook/addFollowRecord',
    name: AddFollowRecord,
    component: AddFollowRecord,
    meta: { title: '添加跟进记录', hideFAB: true }
  },
  {
    path: '/consultationBookDetail',
    name: ConsultationBookDetail,
    component: ConsultationBookDetail,
    meta: { title: '线索详情', hideFAB: true }
  },

  {
    path: '/phoneBankRecord',
    name: PhoneBankRecord,
    component: PhoneBankRecord,
    meta: { title: '号码库记录', hideFAB: true }
  },
  {
    path: '/phoneBankAddRecord',
    name: 'PhoneBankAddRecord',
    component: PhoneBankAddRecord,
    meta: { title: '新增跟进记录', hideFAB: true }
  },
  {
    path: '/addAttendance',
    name: AddAttendance,
    component: AddAttendance,
    meta: { title: '考勤', hideFAB: true }
  }, {
    path: '/editSchedulePlan',
    name: EditSchedulePlan,
    component: EditSchedulePlan,
    meta: { title: '修改排课', hideFAB: true }
  }, {
    path: '/editAttendance',
    name: EditAttendance,
    component: EditAttendance,
    meta: { title: '修改考勤' }
  }, {
    path: '/editAttendanceSchedulePlan',
    name: EditAttendanceSchedulePlan,
    component: EditAttendanceSchedulePlan,
    meta: { title: '修改考勤' }
  }, {
    path: '/teachingLogDetail',
    name: TeachingLogDetail,
    component: TeachingLogDetail,
    meta: { title: '上课详情', hideFAB: true }
  }, {
    path: '/classHourComposition',
    name: 'ClassHourComposition',
    component: () => import('../views/schedule/classHourComposition.vue'),
    meta: { title: '课时构成', hideFAB: true }
  }, {
    path: '/addSchedule',
    name: AddSchedule,
    component: AddSchedule,
    meta: { title: '新增课程' }
  }, {
    path: '/addStudentSchedule',
    name: AddStudentSchedule,
    component: AddStudentSchedule,
    meta: { title: '学生排课', hideFAB: true }
  }, {
    path: '/paySuccess',
    name: PaySuccess,
    component: PaySuccess,
    meta: { title: '支付成功', hideFAB: true }
  },
  {
    path: '/fuiouPay/:payId',
    name: 'FuiouPay',
    component: () => import('../views/order/fuiouPay.vue'),
    meta: { title: '订单详情', hideFAB: true }
  },
  {
    path: '/contractAgreement',
    name: 'ContractAgreement',
    component: () => import('../views/order/contractAgreement.vue'),
    meta: { title: '合同协议', hideFAB: true }
  },
  {
    path: '/contractSign/:orderId/:token',
    name: 'ContractSign',
    component: () => import('../views/order/contractSign.vue'),
    meta: { title: '合同签署', hideFAB: true }
  },
  {
    path: '/signature',
    name: 'Signature',
    component: () => import('../views/order/signature.vue'),
    meta: { title: '手写签名', hideFAB: true }
  },
  {
    path: '/login',
    name: Login,
    component: Login,
    meta: { title: '登陆', hideFAB: true }
  },
  {
    path: '/customer',
    name: CustomerDetail,
    component: CustomerDetail,
    meta: { title: '', hideFAB: true }
  },
  {
    path: '/report/habit',
    name: 'HabitReport',
    component: () => import('../views/report/habitReport.vue'),
    meta: { title: '测评报告', hideFAB: true }
  },
  {
    path: '/report/volunteerSimulation',
    name: 'VolunteerSimulationReport',
    component: () => import('../views/report/volunteerSimulationReport.vue'),
    meta: { title: '志愿模拟报告', hideFAB: true }
  },
  {
    path: '/courseIntroduction',
    name: 'CourseIntroduction',
    component: () => import('../views/courseIntroduction/index.vue'),
    meta: { title: '课程指南', hideFAB: true }
  },
  {
    path: '/courseIntroduction/gradeDetail',
    name: 'GradeDetail',
    component: () => import('../views/courseIntroduction/gradeDetail.vue'),
    meta: { title: '年级课程详情', hideFAB: true }
  },
  {
    path: '/schoolCompleteInfo/schoolDetail',
    name: 'SchoolDetail',
    component: SchoolDetail,
    meta: { title: '学校详情', hideFAB: true }
  },
  {
    path: '/article',
    name: 'Article',
    component: () => import('../views/article/index.vue'),
    meta: { title: '文章详情', hideFAB: true }
  },
  {
    path: '/ketpet',
    name: 'KETPET',
    component: () => import('../views/courseIntroduction/ketpet.vue'),
    meta: { title: 'PET&KET', hideFAB: true }
  },
  {
    path: '/dressUpload',
    name: 'DressUpload',
    component: () => import('../views/dress/upload.vue'),
    meta: { title: '上传', hideFAB: true }
  },
  {
    path: '/dressReport',
    name: 'DressReport',
    component: () => import('../views/dress/report.vue'),
    meta: { title: '报告', hideFAB: true }
  },
  {
    path: '/dressWeekReport',
    name: 'DressWeekReport',
    component: () => import('../views/dress/weekReport.vue'),
    meta: { title: '周报', hideFAB: true }
  },
  {
    path: '/consultationBoard',
    name: 'ConsultationBoard',
    component: () => import('../views/consultationBook/board.vue'),
    meta: { title: '线索看板', hideFAB: true }
  },
  {
    path: '/visitedBoard',
    name: 'VisitedBoard',
    component: () => import('../views/consultationBook/visitedBoard.vue'),
    meta: { title: '到访看板', hideFAB: true }
  },
  {
    path: '/boardCenter',
    name: 'BoardCenter',
    component: () => import('../views/boardCenter/index.vue'),
    meta: { title: '看板中心', hideFAB: true }
  },
  {
    path: '/performanceBoard',
    name: 'PerformanceBoard',
    component: () => import('../views/performanceBoard/index.vue'),
    meta: { title: '业绩看板', hideFAB: true }
  },
  {
    path: '/serviceSubscribe',
    name: 'ServiceSubscribe',
    component: () => import('../views/serviceSubscribe/index.vue'),
    meta: { title: '订阅上课提醒', hideFAB: true }
  },
  {
    path: '/referral',
    name: 'Referral',
    component: () => import('../views/referral/index.vue'),
    meta: { title: '我的推荐', hideFAB: true }
  },
  {
    path: '/referral/mine',
    name: 'ReferralMine',
    component: () => import('../views/referral/mine.vue'),
    meta: { title: '我的推荐', hideFAB: true }
  },
  // {
  //   path: '/activity/childhoodPhoto',
  //   name: 'ChildhoodPhotoActivity',
  //   component: () => import('../views/activity/childhoodPhoto.vue'),
  //   meta: { title: '六一童年照', hideFAB: true }
  // },
  {
    path: '/courseEvaluationDetail/:studentScheduleId',
    name: 'CourseEvaluationDetail',
    component: () => import('../views/schedule/courseEvaluationDetail.vue'),
    meta: { title: '考勤详情', hideFAB: true }
  },
  {
    path: '/courseEvaluate/:studentScheduleId',
    name: 'CourseEvaluate',
    component: () => import('../views/schedule/courseEvaluate.vue'),
    meta: { title: '课程点评', hideFAB: true }
  },
  {
    path: '/activity/lottery',
    name: 'DoubleFestivalLottery',
    component: () => import('../views/activity/lottery.vue'),
    meta: { title: '双节喜抽奖', hideFAB: true }
  },
  {
    path: '/classHourWarnDetail',
    name: 'ClassHourWarnDetail',
    component: () => import('../views/classHourWarn/detail.vue'),
    meta: { title: '课时明细', hideFAB: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 返回/前进时恢复到上次滚动位置
    if (savedPosition) {
      return savedPosition
    }
    // 新进入页面回到顶部
    return { top: 0 }
  }
})

export default router
